/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface ListPlayerActivity200ResponseResultInner
 */
export interface ListPlayerActivity200ResponseResultInner {
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    playerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionEmployee?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionBuyin?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionChipin?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionMinplayed?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionPoints?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionComp?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionBonusPoints?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionWalk?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionSlotpaid?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionAveragebet?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionSlotwager?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionNet?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    transactionStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    showVoid?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    promotionCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    promotionDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200ResponseResultInner
     */
    promotionTicket?: string;
}


/**
 * Check if a given object implements the ListPlayerActivity200ResponseResultInner interface.
 */
export function instanceOfListPlayerActivity200ResponseResultInner(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function ListPlayerActivity200ResponseResultInnerFromJSON(json: any): ListPlayerActivity200ResponseResultInner {
    return ListPlayerActivity200ResponseResultInnerFromJSONTyped(json, false);
}

export function ListPlayerActivity200ResponseResultInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPlayerActivity200ResponseResultInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'playerNumber': !exists(json, 'playerNumber') ? undefined : json['playerNumber'],
        'transactionDate': !exists(json, 'transactionDate') ? undefined : json['transactionDate'],
        'transactionLocation': !exists(json, 'transactionLocation') ? undefined : json['transactionLocation'],
        'transactionEmployee': !exists(json, 'transactionEmployee') ? undefined : json['transactionEmployee'],
        'transactionBuyin': !exists(json, 'transactionBuyin') ? undefined : json['transactionBuyin'],
        'transactionChipin': !exists(json, 'transactionChipin') ? undefined : json['transactionChipin'],
        'transactionMinplayed': !exists(json, 'transactionMinplayed') ? undefined : json['transactionMinplayed'],
        'transactionPoints': !exists(json, 'transactionPoints') ? undefined : json['transactionPoints'],
        'transactionComp': !exists(json, 'transactionComp') ? undefined : json['transactionComp'],
        'transactionBonusPoints': !exists(json, 'transactionBonusPoints') ? undefined : json['transactionBonusPoints'],
        'transactionWalk': !exists(json, 'transactionWalk') ? undefined : json['transactionWalk'],
        'transactionSlotpaid': !exists(json, 'transactionSlotpaid') ? undefined : json['transactionSlotpaid'],
        'transactionValue': !exists(json, 'transactionValue') ? undefined : json['transactionValue'],
        'transactionAveragebet': !exists(json, 'transactionAveragebet') ? undefined : json['transactionAveragebet'],
        'transactionSlotwager': !exists(json, 'transactionSlotwager') ? undefined : json['transactionSlotwager'],
        'transactionNet': !exists(json, 'transactionNet') ? undefined : json['transactionNet'],
        'transactionStatus': !exists(json, 'transactionStatus') ? undefined : json['transactionStatus'],
        'showVoid': !exists(json, 'showVoid') ? undefined : json['showVoid'],
        'promotionCode': !exists(json, 'promotionCode') ? undefined : json['promotionCode'],
        'promotionDesc': !exists(json, 'promotionDesc') ? undefined : json['promotionDesc'],
        'promotionTicket': !exists(json, 'promotionTicket') ? undefined : json['promotionTicket'],
    };
}

export function ListPlayerActivity200ResponseResultInnerToJSON(value?: ListPlayerActivity200ResponseResultInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'playerNumber': value.playerNumber,
        'transactionDate': value.transactionDate,
        'transactionLocation': value.transactionLocation,
        'transactionEmployee': value.transactionEmployee,
        'transactionBuyin': value.transactionBuyin,
        'transactionChipin': value.transactionChipin,
        'transactionMinplayed': value.transactionMinplayed,
        'transactionPoints': value.transactionPoints,
        'transactionComp': value.transactionComp,
        'transactionBonusPoints': value.transactionBonusPoints,
        'transactionWalk': value.transactionWalk,
        'transactionSlotpaid': value.transactionSlotpaid,
        'transactionValue': value.transactionValue,
        'transactionAveragebet': value.transactionAveragebet,
        'transactionSlotwager': value.transactionSlotwager,
        'transactionNet': value.transactionNet,
        'transactionStatus': value.transactionStatus,
        'showVoid': value.showVoid,
        'promotionCode': value.promotionCode,
        'promotionDesc': value.promotionDesc,
        'promotionTicket': value.promotionTicket,
    };
}

